import { render, staticRenderFns } from "./StorePauseView.vue?vue&type=template&id=23de3448&scoped=true"
import script from "./StorePauseView.vue?vue&type=script&lang=js"
export * from "./StorePauseView.vue?vue&type=script&lang=js"
import style0 from "./StorePauseView.vue?vue&type=style&index=0&id=23de3448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de3448",
  null
  
)

export default component.exports